import {
   Platform,
   Text,
   View,
   TouchableOpacity,
   Image,
   ActivityIndicator,
} from 'react-native';
import React from 'react';
import {
   BACK_ARROW_HOVER_TINT_COLOR,
   CONTACT_US,
   FONT_FAMILY_MEDIUM,
   NORCAT_ORG,
   WHITE_BUTTON_HOVER_COLOR,
   isHoverEnabled,
   norcatOrg,
   primaryColor400,
   primaryColor500,
   redirectToBrowser,
   white,
   isMacOS,
   ActivityLoaderColor,
} from '../../utils/utils';
/**
 * @NorcatOrgBtn
 * @Button Hyperlink
 * @for Norcat.org
 */
export const NorcatOrgBtn = () => {
   const [isHover, setHover] = React.useState(false);
   return (
      <TouchableOpacity
         style={{
            backgroundColor: isHover ? WHITE_BUTTON_HOVER_COLOR : white,
            paddingTop: 8,
            paddingBottom: 8,
            marginBottom: 5,
            paddingLeft: 20,
            paddingRight: 20,
            borderRadius: 5,
            borderWidth: 1,
            borderColor: primaryColor400,
            marginTop: 16,
            ...Platform.select({
               windows: {
                  paddingBottom: 9,
               },
            }),
         }}
         onMouseEnter={() => {
            setHover(true);
         }}
         onMouseLeave={() => {
            setHover(false);
         }}
         onPress={() => {
            redirectToBrowser({url: NORCAT_ORG});
         }}>
         <Text
            style={{
               textAlign: 'center',
               textAlignVertical: 'center',
               color: primaryColor500,
               fontSize: 14,
               fontWeight: '700',
               fontFamily: FONT_FAMILY_MEDIUM,
            }}>
            {norcatOrg}
         </Text>
      </TouchableOpacity>
   );
};

/**
 * @ContactUsLink
 * @Button Hyperlink
 */
export const ContactUsLink = () => {
   const [isHover, setHover] = React.useState(false);
   return (
      <TouchableOpacity
         onMouseEnter={() => {
            setHover(true);
         }}
         onMouseLeave={() => {
            setHover(false);
         }}
         onPress={() => {
            redirectToBrowser({url: CONTACT_US});
         }}>
         {isMacOS ? (
            <Text
               style={{
                  fontSize: 14,
                  fontWeight: '700',
                  textAlign: 'center',
                  color: primaryColor500,
                  marginLeft: 8,
                  fontFamily: FONT_FAMILY_MEDIUM,
                  textDecorationLine:
                     isHover && isHoverEnabled ? 'underline' : 'none',
               }}>
               Contact Us
            </Text>
         ) : (
            <Text
               style={{
                  fontSize: 14,
                  fontWeight: '700',
                  textAlign: 'center',
                  color: primaryColor500,
                  marginLeft: 8,
                  fontFamily: FONT_FAMILY_MEDIUM,
                  textDecorationLine:
                     isHover && isHoverEnabled ? 'underline' : 'none',
               }}>
               Contact Us
            </Text>
         )}
      </TouchableOpacity>
   );
};
/**
 * @BackArrow
 * @Button Hyperlink
 */
export const BackArrowLink = props => {
   const [isHover, setHover] = React.useState(false);
   return (
      <TouchableOpacity
         style={{
            padding: 10,
            alignContent: 'center',
         }}
         onMouseEnter={() => {
            setHover(true);
         }}
         onMouseLeave={() => {
            setHover(false);
         }}
         onPress={props?.onPress}>
         <Image
            source={require('../../assets/back_arrow.png')}
            style={{
               width: 16,
               height: 16,
               top: 0,
               tintColor: isHover ? BACK_ARROW_HOVER_TINT_COLOR : white,
            }}
         />
      </TouchableOpacity>
   );
};

/**
 * @Name:ContainerWrapper
 * @for center align
 * @Loader/Spiner
 * @NO DATA AVAILABLE
 * @wrapper
 * @props are
 * loading-boolean
 * emptyData - boolean
 * containerStyle - css/object
 * txt - string
 */
export const ContainerWrapper = props => {
   if (props?.loading) {
      return (
         <View
            style={[
               {
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'center',
               },
               props?.containerStyle,
            ]}>
            <ActivityIndicator
               size="large"
               color={props?.color ?? ActivityLoaderColor}
               style={{
                  position: 'absolute',
                  top: props?.top ?? 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  zIndex: 1,
               }}
            />
         </View>
      );
   }
   if (props?.emptyData) {
      return (
         <React.Fragment>
            <View
               style={[
                  {
                     flex: 1,
                     alignItems: 'center',
                     justifyContent: 'center',
                  },
                  props?.containerStyle,
               ]}>
               <Text
                  style={{
                     textAlign: 'center',
                  }}>
                  {props?.txt ?? 'NO DATA AVAILABLE'}
               </Text>
            </View>
         </React.Fragment>
      );
   }
   return <React.Fragment>{props?.children}</React.Fragment>;
};
